import React from "react";
import { InputNumber, Form, Alert } from "antd";
import CurrencySelector from "components/CurrencySelector_new";
import "./MoneyInputWithCurrencySelector_new.scss";
import { formatMoney } from 'utils/utils';

export default class MoneyInputWithCurrencySelector extends React.Component {
  state = {
    error: false
  };

  handleCurrencyChange = newSelectedCurrency => {
    if (this.props.onChange) {
      this.props.onChange(
        { amount: this.props.value.amount, currency: newSelectedCurrency },
        "CURRENCY"
      );
    }
  };

  handleAmountChange = newAmount => {
    if (newAmount <= 0) {
      this.setState({ error: true });
      return;
    }
    if (this.props.onChange) {
      this.props.onChange(
        { amount: newAmount, currency: this.props.value.currency },
        "AMOUNT"
      );
    }
    this.setState({ error: false });
  };

  render() {
    let amount = this.props.value.amount;
    if (this.props.targetField && (this.props.value.currency === 'VND' || this.props.value.currency === 'IDR')) {
      amount = Math.round(this.props.value.amount);
    }
    const {
      title,
      placeholder,
      value,
      allowedCurrencies,
      allowedBeneficiaryCountries,
      sourceCurrency,
    } = this.props;

    return (
      <Form.Item label={<label style={{ color: this.props.labelColor || "black", fontWeight: "bold" }}>{title}</label>}>
        <div className="money-input-container" >
          <InputNumber
            className="amount-field"
            placeholder={placeholder}
            onChange={this.handleAmountChange}
            onBlur={({ target }) => this.handleAmountChange(target.value)}
            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            precision={2}
            value={formatMoney(amount, 2)}
            style={{ width: '60%', border: 'none', textAlign: 'right', paddingRight: '10px', marginRight: '16px' }}
          />
          <CurrencySelector
            className="currency-field"
            defaultValue={value.currency}
            currencies={allowedCurrencies}
            beneficiaryCountries={allowedBeneficiaryCountries || []}
            sourceCurrency={sourceCurrency}
            onCurrencyChanged={this.handleCurrencyChange}
            style={{ border: 'none', width: '40%', paddingLeft: '10px' }}
          />

          {/*{this.state.error && (*/}
          {/*  <div className="ant-form-explain">*/}
          {/*    Source Amount cannot be less than 0*/}
          {/*  </div>*/}
          {/*)}*/}
          {this.props.errorMsgOverLimit &&
            <div style={{ marginTop: "5px" }}>
              <Alert message={this.props.errorMsgOverLimit} type="error" />
            </div>}
        </div>
      </Form.Item>
    );
  }
}
